var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMegaphone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    className: "bob-core-components-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "icons/_tint/megaphone"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 11.55c1.65 0 3-1.35 3-3s-1.35-3-3-3v6z",
    className: "secondarytint"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 13.05l4 7h2.2c.4 0 .7-.4.55-.75L9 13.05H4.5z",
    className: "tertiarytint"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5 10.35c0-1.6-1.05-2.9-2.5-3.35V3.55c0-.6-.5-1-1-1-.15 0-.35.05-.5.15l-6.3 3.05c-.15.1-.3.15-.5.15H3c-.55 0-1 .45-1 1v7.15c0 .55.45 1 1 1h.5l3.6 6.7c.1.15.25.3.45.3h2.95c.35 0 .6-.35.45-.7l-2.55-6.3h2.4c.15 0 .3.05.45.1l6.35 2.8c.15.05.3.1.45.1.5 0 1-.4 1-1V13.7c1.4-.45 2.45-1.75 2.45-3.35zM9.8 21.05H7.85l-3.2-6h2.7l2.45 6zm8.2-4l-6.35-2.8c-.05-.05-.1-.05-.15-.05v-3.35c0-.3-.2-.5-.5-.5s-.5.2-.5.5v3.2H3v-7.2h7.75c.35 0 .65-.1.95-.25L18 3.55v13.5zm1-4.4v-4.6c.9.4 1.5 1.25 1.5 2.3 0 1.05-.6 1.9-1.5 2.3zM6.5 8.35c0 .3-.2.5-.5.5H4.5c-.3 0-.5-.2-.5-.5s.2-.5.5-.5H6c.3 0 .5.25.5.5zm0 2c0 .3-.2.5-.5.5H4.5c-.3 0-.5-.2-.5-.5s.2-.5.5-.5H6c.3 0 .5.25.5.5z",
    className: "primarytint"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaphone);
export default __webpack_public_path__ + "static/media/megaphone.5c0b562f5330faa472ada50a78d3660e.svg";
export { ForwardRef as ReactComponent };